module.exports = __webpack_public_path__ + "static/media/Metodologia - Cálculo de perdas elétricas.cf28372d.pdf";